export default {
  button: {
    confirm: "Confirm",
    cancel: "Cancel",
    create: "Create",
  },
  search: "Search",
  edit: "Edit",
  create: "Create",
  userName: "User Name",
  password: "Password",
  information: "Information",
  deleteSuccess: "delete success!",

  route: {
    dashboard: "Index",
    documentation: "Documentation",
    guide: "Guide",
    permission: "Permission",
    pagePermission: "Page Permission",
    rolePermission: "Role Permission",
    directivePermission: "Directive Permission",
    icons: "Icons",
    components: "MemoryMap",
    tinymce: "Tinymce",
    markdown: "Markdown",
    jsonEditor: "JSON Editor",
    dndList: "待定",
    splitPane: "SplitPane",
    avatarUpload: "Avatar Upload",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    ipuvm: "IP UVM complex test",
    componentMixin: "Mixin",
    backToTop: "Back To Top",
    dragDialog: "Drag Dialog",
    dragSelect: "查询表格",
    dragKanban: "待定",
    charts: "SoC Generator",
    keyboardChart: "SoC画布",
    lineChart: "CRG Gen",
    mixChart: "CSR Gen",
    PINMUXGen: "PINMUX Gen",
    example: "Regression & Debug",
    nested: "RISC-V Core Generator",
    menu1: "微架构",
    "menu1-1": "Core-Base Options",
    "menu1-2": "Memory-Path Options",
    "menu1-2-1": "菜单 1-2-1",
    "menu1-2-2": "菜单 1-2-2",
    "menu1-3": "Core-Auxiliary Options",
    "menu1-4": "Core-Advanced Options",
    "menu1-5": "Implement-Related Options",
    menu2: "定制指令与编译工具链",
    menu3: "基础计算库",
    Table: "Test Generator",
    dynamicTable: "Core delivery test generator",
    dragTable: "Core UVM complex test",
    inlineEditTable: "Core special test editor",
    complexTable: "SoC delivery test generator",
    SoCEditor: "SoC special test editor",
    FaultInjectGenerator: "Fault Inject Generator",
    tab: "Tab",
    form: "Form",
    createArticle: "回归配置与编辑",
    defectManagement: "Defect Management",
    editArticle: "Waveform Debug",
    articleList: "回归结果管理",
    caseArticle: "CASE结果管理",
    baseArticle: "基础配置",
    wavedrom: "wavedrom",
    system: {
      name: "系统管理",
      user: "用户管理",
      role: "角色管理",
      menu: "菜单管理",
      dept: "项目管理",
      dict: "字典",
    },
    errorPages: "OS & BSP Generator",
    page401: "OS porting",
    page404: "BSP Generator",
    applicationEditor: "Application editor",
    errorLog: "错误日志",
    excel: "Excel",
    exportExcel: "导出 Excel",
    selectExcel: "导出 已选择项",
    mergeHeader: "导出 多级表头",
    uploadExcel: "上传 Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "Export Zip",
    theme: "Theme",
    clipboardDemo: "Clipboard",
    i18n: "I18n",
    externalLink: "External Link",
    profile: "Profile",
    upload_success: "upload_success",
  },
  profile: {
    newProject: "New Project",
    joinProject: "Join Project",
    projectName: "Project Name",
    editProfile: "Edit Profile",
    projectInfo: "Project Info",
    gitInfo: "Git Info",
    member: "Member",
    default: "Default",
    dissolve: "Dissolve",
    setAsDefault: "Set as default",
    form: {
      inviteCode: "Invite Code",
      invite: "Invite",
      approval: "Approval",
      createBy: "Create By",
      createTime: "Create Time",
      email: "email",
      role: "Role",
      status: "Status",
      allowed: "Allowed",
      refused: "Refused",
      name: "Name",
      role: {
        role: "Role",
        lead: "lead",
        architecture: "Architecture",
        hardware: "Hardware",
        verify: "Verify",
        software: "Software",
        backEndEngineer: "Back-End Engineer",
      },
      rule: {
        tooltip: {
          projectName: "Project name required",
          gitAddress: "The Git address is required",
          gitUsername: "The Git username is required",
          gitPassword: "The Git password is required",
        },
      },
    },
    userCard: {
      name: "Name",
      updatePassword: "Update Password",
    },
    account: {
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      updatePassword: "Update Password",
      currentPasswordInfo: "Please enter the current account password.",
      newPasswordInfo:
        "The new password cannot be the same as the current one.",
      confirmPasswordInfo:
        "The confirmation password and the new password must be the same.",
      cancel: "Cancel",
      submit: "Submit",
      updateSuccessfully: "Update password successfully, please log in again",
    },
    project: {
      createProject: "Create Project",
      name: "Project Name",
      gitAddress: "Git Address",
      gitUserName: "Git Username",
      gitPassword: "Git Password / Token (recommend to use token) ",
      editMode: "Edit Mode",
    },
  },
  navbar: {
    dashboard: "Dashboard",
    github: "Github",
    logOut: "Log Out",
    profile: "Profile",
    theme: "Theme",
    size: "Global Size",
  },

  account: {
    username: "Username",
    password: "Password",
    email: "Email",
    phone: "Phone",
  },
  login: {
    title: "Login Form",
    logIn: "Login",
    forgotPassword: "forgot password?",
    rememberMe: "remember me",
    register: "register",
    registeredSuccessfully:
      "Registration successful. You will be redirected to the homepage to log in",
    resetSuccessfully: "Reset password successfully, please log in again",
    resetPassword: "reset password",
    cancel: "cancel",
    registerInfo: `Don't have an account? Click to`,
    username: "Username",
    password: "Password",
    any: "any",
    thirdparty: "Or connect with",
    thirdpartyTips:
      "Can not be simulated on local, so please combine you own business simulation! ! !",
  },
  register: {
    confirm: "Confirm",
    placeholder: {
      enterUsername: "Please enter your username",
      enterEmail: "Please enter your email",
      enterEmailAddr: "Please enter a valid email address",
      enterPassword: "Please enter your password",
      enterPhonenumber: "Please enter your phonenumber",
      confirmPassword: "Please confirm your password",
      pwdNotMatch: "Passwords do not match",
    },
    agreementInfo: "I have read and agree to the ",
    agreementContent:
      "One Step Chip Platform User Service Agreement and Privacy Policy",
    agreeAndContinue: "Agree and continue",
    needToAgreeInfo: "You need to agree to the agreement before registration",
  },

  documentation: {
    documentation: "Documentation",
    github: "Github Repository",
  },
  permission: {
    addRole: "New Role",
    editPermission: "Edit",
    roles: "Your roles",
    switchRoles: "Switch roles",
    tips: "In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.",
    delete: "Delete",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  guide: {
    description:
      "The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ",
    button: "Show Guide",
  },
  components: {
    documentation: "Documentation",
    tinymceTips:
      "Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.",
    dropzoneTips:
      "Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.",
    stickyTips:
      "when the page is scrolled to the preset position will be sticky on the top.",
    backToTopTips1:
      "When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner",
    backToTopTips2:
      "You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally",
    imageUploadTips:
      "Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.",
  },
  table: {
    dynamicTips1: "Fixed header, sorted by header order",
    dynamicTips2: "Not fixed header, sorted by click order",
    dragTips1: "The default order",
    dragTips2: "The after dragging order",
    title: "Title",
    importance: "Imp",
    type: "Type",
    remark: "Remark",
    search: "Search",
    add: "Add",
    export: "Export",
    reviewer: "reviewer",
    id: "ID",
    date: "Date",
    author: "Author",
    readings: "Readings",
    status: "Status",
    actions: "Actions",
    edit: "Edit",
    publish: "Publish",
    draft: "Draft",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    regressionList: "regressionList",
    regressionName: "regressionName",
    regressionDate: "regressionDate",
    rtlVersion: "rtlVersion",
    rtlType: "rtlType",
    caseNum: "caseNum",
    regressionResult: "regressionResult",
    compilerFailNum: "compilerFailNum",
    simulateFailNum: "simulateFailNum",
    simulateFailList: "simulateFailList",
    simulateWaveForm: "simulateWaveForm",
    process: "process",
    viewWave: "viewWave",
    viewResult: "simulateWaveForm",
    caseName: "caseName",
    caseType: "caseType",
    caseCommand: "caseCommand",
    isFixed: "isFixed",
    rerunCase: "rerunCase",
    relatedLog: "relatedLog",
    userName: "userName",
    view: "view",
    project: "project",
    gitAddress: "gitAddress",
    gitUser: "gitUser",
    gitPassword: "gitPassword",
    projectPath: "projectPath",
    delRepo: "delRepo",
  },
  example: {
    warning:
      "Creating and editing pages cannot be cached by keep-alive because keep-alive include does not currently support caching based on routes, so it is currently cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or do not use keep-alive include to cache all pages directly. See details",
    bug: {
      titleInfo: "After entering the scope, press Enter to apply.",
      createBug: "Create Bug",
      manager: "Manager",
      form: {
        scope: "Scope",
        branch: "Branch",
        commitID: "Commit ID",
        newScope: "New Scope",
        label: "Label",
        title: "Title",
        severity: "Severity",
        priority: "Priority",
        createItem: "Create Item",
        status: "Status",
        Open: "Open",
        NotStarted: "Not Started",
        Running: "Running",
        Completed: "Completed",
        WaitVerify: "Wait Verify",
        createTime: "Create Time",
        finishTime: "Finish Time",
        severityStatus: "severity",
        normal: "normal",
        minor: "minor",
        IU: "Important and urgent",
        INU: "Important but not urgent",
        UNI: "Not important but urgent",
        NINU: "Not important and not urgent",
        assigner: "Assigner",
        assignee: "Assignee",
        description: "Description",
        reply: "Reply",
      },
      branch: {
        branch: "Branch",
        addBranch: "Add Branch",
        updateBranch: "Update Branch",
        placeholder: "please enter branch",
        description: "Description",
        nullInfo: "The branch name is null",
        nullAndDuplicatedInfo: "The branch name is null or duplicated",
        indexCanNotEditInfo: "The index can not edit",
        defaultName: "default name",
        defaultDesc: "default description",
        notDuplicatedNameInfo: "Branch names cannot be duplicated:",
      },
      placeholder: {
        selectLabel: "Please select label",
        enterTitle: "Please enter a bug title",
        enterCommitID: "Please enter a commit ID",
        selectAssigner: "Please select assigner",
        selectAssignee: "Please select assignee",
        selectSeverity: "Please select severity",
        selectPriority: "Please select priority",
        enterSearch: "Please enter the search content",
        selectScope: "Please select scope",
        selectBranch: "Please select branch",
        enterBranch: "Please enter branch",
        enterBranchDesc: "Please enter branch description",
      },
      formRulesMessage: {
        title: "Please fill in the bug title information",
        label: "Please select in the label information",
      },
      confirm: {
        deleteTag: "delete target label or not?",
        deleteBranch: "delete target branch or not?",
      },
    },
  },
  errorLog: {
    tips: "Please click the bug icon in the upper right corner",
    description:
      "Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.",
    documentation: "Document introduction",
  },
  excel: {
    export: "Export",
    selectedExport: "Export Selected Items",
    placeholder: "Please enter the file name (default excel-list)",
  },
  zip: {
    export: "Export",
    placeholder: "Please enter the file name (default file)",
  },
  pdf: {
    tips: "Here we use window.print() to implement the feature of downloading PDF.",
  },
  theme: {
    change: "Change Theme",
    documentation: "Theme documentation",
    tips: "Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.",
  },
  tagsView: {
    refresh: "Refresh",
    close: "Close",
    closeOthers: "Close Others",
    closeAll: "Close All",
  },
  settings: {
    title: "Page style setting",
    theme: "Theme Color",
    tagsView: "Open Tags-View",
    fixedHeader: "Fixed Header",
    sidebarLogo: "Sidebar Logo",
  },
};
